<template>
  <v-container class="px-0">
    <v-row no-gutters class="px-6">
      <v-col align-self="center" cols="auto"
        ><v-row no-gutters class="text-h5 font-weight-bold"
          ><span class="main-font secondary--text">Sharings</span></v-row
        ></v-col
      >
      <v-col cols="auto" v-if="!visitor" align-self="center" class="pl-5">
        <label for="add-plant-sharing">
          <v-icon color="primary" class="mt-n1">mdi-camera-plus-outline</v-icon>
        </label>
      </v-col>
    </v-row>
    <v-tabs
      v-model="tab"
      active-class="selected-tab"
      hide-slider
      class="my-2"
      :show-arrows="false"
    >
      <v-tab
        v-for="(item, index) in items"
        :key="item"
        class="text-none rounded-pill"
        style="opacity: 0.5; overflow: hidden"
      >
        <v-container>
          <v-row no-gutters class="text-h6 font-weight-light">{{ item }}</v-row>
          <v-fade-transition>
            <v-row no-gutters justify="center" v-if="tab === index">
              <div class="point-tab"></div></v-row
          ></v-fade-transition>
        </v-container>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="pt-2 pb-16 transparent">
      <v-tab-item> <PlantsSharing /> </v-tab-item
      ><v-tab-item>
        <v-row no-gutters justify="center" class="mt-10 primary--text"
          >Tips feature coming soon</v-row
        >
      </v-tab-item>
    </v-tabs-items>

    <input
      type="file"
      id="add-plant-sharing"
      @change="onFileChange"
      accept="image/*"
      style="display: none"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { ISOToRelativeTime } from "@/utils/dates.js";
import resizePicture from "@/utils/resizePicture.js";
import PlantsSharing from "./PlantsSharing.vue";

export default {
  name: "Sharings",
  components: {
    PlantsSharing,
  },
  data() {
    return {
      tab: 0,
      items: ["Plants To Give", "Tips"],
    };
  },
  computed: {
    gardenId() {
      return this.$route.params.gardenId;
    },
    visitor() {
      return this.gardenId !== this.self.id;
    },
    ...mapState("self", ["self", "selfPending"]),
    ...mapState("plants", ["plant", "plants", "plantsPending"]),
  },
  methods: {
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    async onFileChange(e) {
      try {
        const dataurl = await resizePicture(e.target.files[0], 1000, 1000);
        this.$store.dispatch("plants/uploadPlantPicture", {
          picture: dataurl,
          status: "to-give",
        });
        this.$store.dispatch("level/updateLevel", {
          field: "toGive",
          value: true,
        });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style >
.v-tabs-bar {
  background-color: transparent !important;
}
.v-tab--active::before {
  opacity: 0 !important;
}
.selected-tab {
  opacity: 1 !important;
}
.point-tab {
  background-color: var(--v-primary-base);
  width: 4px;
  height: 4px;
  border-radius: 2px;
  position: absolute;
}
</style>